// import { grey } from "@material-ui/core/colors"

export const colors = {
    greyText: '#8181A5',
    greyBg: '#F0EFF2',
    brandColor: '#48AC98',
    white: '#ffffff',
    lightWhite: '#F9FCF8',
    lightGray: '#F9FAFB',

    primary: {
        main: '#9EE870',
        dark: '#173300',
        aquamarine: '#73EDB8',
    },
    secondary: {
        main: '#1E1E1E',
    },
    gray: {
        main: '#F0EFF2',
        dark: '#8181A5',
        alternative: '#6B7280',
        light: '#B6D8C0'
    },
    text: {
        primary: '#1B2524',
        secondary: '#173300',
    },
    neutral: {
        50: '#fafafa',
        100: '#eff3f3',
        200: '#ced6d6',
        300: '#92a0a1',
        400: '#304547',
        500: '#172c2d',
        600: '#112122',
        700: '#061717',
    },
    success: {
        50: '#e9fcf5',
        100: '#24de9c',
        200: '#18ba81',
    },
};